import { useEffect, useState } from "react";
import { checkImageQuality, qualityText } from "./index";

// Runs the KYC image pre-check on `image` and returns
// { status: "idle" | "checking" | "pass" | "fail", messages, canOverride }.
export const useImageQualityCheck = (image, { mode, side, _t }) => {
  const [state, setState] = useState({
    status: "idle",
    issues: [],
    canOverride: false,
  });

  useEffect(() => {
    if (!image) {
      setState({ status: "idle", issues: [], canOverride: false });
      return undefined;
    }

    let cancelled = false;
    setState({ status: "checking", issues: [], canOverride: false });
    checkImageQuality(image, { mode, side })
      .then((result) => {
        if (cancelled) return;
        setState({
          status: result.passed ? "pass" : "fail",
          issues: result.issues,
          canOverride: result.canOverride,
        });
      })
      .catch((err) => {
        console.error("Image quality check failed:", err);
        // Never block the user because the check itself broke.
        if (!cancelled)
          setState({ status: "pass", issues: [], canOverride: false });
      });

    return () => {
      cancelled = true;
    };
  }, [image, mode, side]);

  const messages = state.issues.map((key) => qualityText(_t, key));

  return { ...state, messages };
};
